

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/login/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/6.B2oMEQKr.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/BCt2Yrch.js","_app/immutable/chunks/DjbxhWhX.js","_app/immutable/chunks/BELN90BF.js","_app/immutable/chunks/DcKRL2at.js"];
export const stylesheets = [];
export const fonts = [];
